import { InjectionToken } from '@angular/core';

export const PATH_PREFIX: InjectionToken<string> = new InjectionToken<string>('PathPrefix');
